import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

export const useModalHandle = () => {
  const [isModalOpen, setOpen] = useState(false);
  const handleModalOpen = useCallback(() => setOpen(true), []);
  const handleModalClose = useCallback(() => setOpen(false), []);

  return {
    isModalOpen,
    handleModalOpen,
    handleModalClose
  };
};

const ComponentWithModal = ({ WrappedComponent, ...props }) => {
  const modalHandle = useModalHandle();
  return <WrappedComponent {...props} {...modalHandle} />;
};

ComponentWithModal.propTypes = {
  WrappedComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
    .isRequired
};

const withModalHandle = () => WrappedComponent => props =>
  <ComponentWithModal {...props} WrappedComponent={WrappedComponent} />;

export default withModalHandle;
